import { PPFeature, PPLimit, PPProduct } from 'shared'
import { PPAddOn } from 'shared/types'

export interface ProductState {
  products: PPProduct[]
  // Purchasable add-on SKUs, refreshed on every backend response that carries `subscriptions.addons`
  addons: PPAddOn[]
  features: PPFeature[]
  limits: PPLimit[]
  featureUpgrade?: string
  productUpgrade?: string
  displayContentUpgradePopup: boolean
  purchasedAddOns: Record<string, number>
  pendingAddonDowngrades?: Record<string, number>
  closeUpgradePopupCallback?: () => void
}

export function initialState(): ProductState {
  return {
    products: [],
    addons: [],
    displayContentUpgradePopup: true,
    features: [],
    limits: [],
    purchasedAddOns: {},
    pendingAddonDowngrades: {}
  }
}
